import { render, staticRenderFns } from "./rank-preview-dialog.vue?vue&type=template&id=72820996&scoped=true"
import script from "./rank-preview-dialog.vue?vue&type=script&lang=js"
export * from "./rank-preview-dialog.vue?vue&type=script&lang=js"
import style0 from "./rank-preview-dialog.vue?vue&type=style&index=0&id=72820996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72820996",
  null
  
)

export default component.exports